import { Injectable } from '@angular/core';

export const modbusServicesLabels = ({
  "AutoTestPage.Forbidden": "Forbidden",
  "AutoTestPage.Incorrect": "Incorrect",
  "AutoTestPage.NoResponse": "No Response",
  "AutoTestPage.QuickRunning": "Quick Running (In progress)",
  "AutoTestPage.Refused": "Refused",
  "AutoTestPage.resolveSuccess": "Success",
  "AutoTestPage.StandardRunning": "Standard Running (In progress)",
  "AutoTestPage.StorageFailed": "Storage Failed",
  "Bluetooth.enableBluetoothIsRequired": "Enable Bluetooth is required",
  "Bluetooth.retryAfterEnableBluetooth": "Retry after enable Bluetooth",
  "BTS5k.bduId": "BDU ID",
  "BTS5k.bduSn": "BDU Serial Number",
  "BTS5k.bmsSysTime": "BMS Time",
  "BTS5k.bmsVersion": "BMS Version",
  "BTS5k.fwVersion": "Firmware Version",
  "BTS5k.packRtCellMaxVoltage": "Max Voltage",
  "BTS5k.packRtCellMinVoltage": "Min Voltage",
  "BTS5k.packRtCurrent": "Current",
  "BTS5k.packRtCycles": "Recharge Cycles",
  "BTS5k.packRtSn": "Serial Number",
  "BTS5k.packRtSoc": "SOC",
  "BTS5k.packRtTemperature1Pack": "Temperature 1",
  "BTS5k.packRtTemperature2Pack": "Temperature 2",
  "BTS5k.packRtTemperature3Pack": "Temperature 3",
  "BTS5k.packRtTemperature4Pack": "Temperature 4",
  "BTS5k.packRtTotalVoltage": "Total Voltage",
  "BTS5k.pcuDcHighVoltage": "DC High Voltage",
  "BTS5k.pcuDcLowVoltage": "DC Low Voltage",
  "BTS5k.pcuInternalTemperature": "Internal Temperature",
  "BTS5k.pcuLowCurrent": "Low Current",
  "BTS5k.pcuLowPower": "Low Power",
  "BTS5k.pcuRadiatorTemperature1": "Radiator Temperature 1",
  "BTS5k.pcuRadiatorTemperature2": "Radiator Temperature 2",
  "BTS5k.pcuSn": "Serial Number",
  "BTS5k.pcuSoftwareVersion": "Software Version",
  "BTS5k.pcuWorkState": "Work State",
  "BTS5k.soh": "SOH",
  "Common.disabled": "Disabled",
  "Common.enabled": "enabled",
  "Common.friday": "Friday",
  "Common.monday": "Monday",
  "Common.notUse": "Not use",
  "Common.notUsed": "Not used",
  "Common.saturday": "Saturday",
  "Common.sunday": "Sunday",
  "Common.thursday": "Thursday",
  "Common.tuesday": "Tuesday",
  "Common.unableToOpenSocket": "Unable to open socket, please try again after a few seconds",
  "Common.unsupportedStickLogger": "Stick Logger not supported",
  "Common.wednesday": "Wednesday",
  "DeviceInfoPage.activePowerDerate": "Active power derate",
  "DeviceInfoPage.antiBackflowOverloadControl": "Anti Backflow overload control",
  "DeviceInfoPage.battery": "Battery pack N° {{value}}",
  "DeviceInfoPage.batteryChargingPowerDerateByLowVoltage": "Battery charging power derate by low voltage",
  "DeviceInfoPage.batteryChargingPowerDerateLeadingHighVoltage": "Battery charging power derate leading high voltage",
  "DeviceInfoPage.chargeEnable": "Charge control",
  "DeviceInfoPage.disableAntiReflux": "Disabled",
  "DeviceInfoPage.disableBatteryActive": "Disabled",
  "DeviceInfoPage.disableBatteryActiveOneShot": "Disable battery active one-shot",
  "DeviceInfoPage.disabled": "Disabled",
  "DeviceInfoPage.disableEmergencyPowerSupply": "Disabled",
  "DeviceInfoPage.disableScanCurve": "Disabled",
  "DeviceInfoPage.disableUnbalancedSupport": "Disabled",
  "DeviceInfoPage.dischargeEnable": "Discharge control",
  "DeviceInfoPage.enableAntiRefluxMeanValue": "Enable anti reflux mean value",
  "DeviceInfoPage.enableAntiRefluxMinPower": "Enable anti reflux min power",
  "DeviceInfoPage.enableBatteryActive": "Enable battery active",
  "DeviceInfoPage.enableBatteryActiveOneShot": "Enable battery active one-shot",
  "DeviceInfoPage.enableEmergencyPowerSupplyDisableColdStart": "Enable emergency power supply, disable cold start",
  "DeviceInfoPage.enableEmergencyPowerSupplyEnableColdStart": "Enable emergency power supply, enable cold start",
  "DeviceInfoPage.enableScanCurve": "Enabled",
  "DeviceInfoPage.enableUnbalancedSupport": "Enabled",
  "DeviceInfoPage.groundTestingEnableBit": "Ground testing enable bit",
  "DeviceInfoPage.independentMode": "Independent Mode",
  "DeviceInfoPage.insulationResistanceTestingEnableBit": "Insulation resistance testing enable bit",
  "DeviceInfoPage.logicInterfaceDrm1-8": "Logic interface (DRM1-8)",
  "DeviceInfoPage.master": "Master",
  "DeviceInfoPage.minutes": "minutes",
  "DeviceInfoPage.notAvailable": "Not Available",
  "DeviceInfoPage.parallelMode": "Parallel Mode",
  "DeviceInfoPage.powerDerateLeadingByHighACVoltage": "Power derate leading by high AC voltage",
  "DeviceInfoPage.pv": "PV N° {{value}}",
  "DeviceInfoPage.pvAndBattery": "PV and Battery",
  "DeviceInfoPage.remotelyOnOffControl": "Remotely control",
  "DeviceInfoPage.seconds": "seconds",
  "DeviceInfoPage.slave": "Slave",
  "DeviceInfoPage.voltageDropoutPTCurveControl": "Voltage dropout PT curve control",
  "report.ActiveOutputDownSpeed": "Overvoltage Load Reduction Rate",
  "report.ActiveOutputLimit": "Active Output Percentage",
  "report.AntiBackflowOverloadEnable": "Anti-Backflow Overload",
  "report.BatteryChargingPowerDerateByLowVoltage": "Battery Charging Power Reduction for Low Voltage",
  "report.BatteryChargingPowerDerateLeadingHighVoltage": "Battery Charging Power Reduction for High Voltage",
  "report.ChargeReactiveEnable": "Charge Reactive Enable",
  "report.ChgDerateMinPower": "Minimum Power with Charging Reduction",
  "report.ChgDerateVoltEnd": "Final Voltage with Charging Reduction",
  "report.ChgDerateVoltStart": "Initial Voltage with Charging Reduction",
  "report.ConnectWaitTime": "Connect Wait Time",
  "report.DCIConfig": "DCI Configuration",
  "report.DCIFirstProtectionProportion": "DCI First Protection Proportion",
  "report.DCIFirstProtectionTime": "DCI First Protection Time",
  "report.DCIFirstProtectionValue": "DCI First Protection Value",
  "report.DCIPhaseRTestingValue": "DCI Phase R Testing Value",
  "report.DCIPhaseSTestingValue": "DCI Phase S Testing Value",
  "report.DCIPhaseTTestingValue": "DCI Phase T Testing Value",
  "report.DCISecondProtectionProportion": "DCI Second Protection Proportion",
  "report.DCISecondProtectionTime": "DCI Second Protection Time",
  "report.DCISecondProtectionValue": "DCI Second Protection Value",
  "report.DCITestingEnable": "DCI Testing Enable",
  "report.DCIThirdProtectionProportion": "DCI Third Protection Proportion",
  "report.DCIThirdProtectionTime": "DCI Third Protection Time",
  "report.DCIThirdProtectionValue": "DCI Third Protection Value",
  "report.DeratingMode": "Power Derating Mode",
  "report.DRM0": "DRM0",
  "report.EnableDerateStartFromRatedPower": "Enable Derate Starting from Rated Power",
  "report.EnableDeratingSlopeCalculateByCurrentPower": "Enable Derating Slope Calculation Based on Current Power",
  "report.EnableHigherFrequencyPowerDerate": "Enable Power Derating at Higher Frequency",
  "report.EnableHigherFrequencyPowerReload": "Enable Power Reload at Higher Frequency",
  "report.EnableLowerFrequencyPowerDerate": "Enable Power Derating at Lower Frequency",
  "report.EnableLowerFrequencyPowerReload": "Enable Power Reload at Lower Frequency",
  "report.EnableReactiveMode3": "Enable Reactive Mode 3",
  "report.EnableReactivePower": "Enable Reactive Power",
  "report.EnergyStorageSegmentationCurveEnable": "Enable Energy Storage Segmentation Curve",
  "report.ESSFrequencyRecoverMax": "Maximum ESS Frequency Recovery",
  "report.ESSFrequencyRecoverMin": "Minimum ESS Frequency Recovery",
  "report.ESSOverfrequencyEnd": "ESS Overfrequency End",
  "report.ESSOverFrequencyReloadDelay": "ESS Overfrequency Reload Delay",
  "report.ESSOverFrequencyReloadSpeed": "ESS Overfrequency Reload Speed",
  "report.ESSOverfrequencyReloadStart": "ESS Overfrequency Reload Start",
  "report.ESSOverFrequencyResponseDelay": "ESS Overfrequency Response Delay",
  "report.ESSOverFrequencySlope": "ESS Overfrequency Slope",
  "report.ESSOverFrequencyStart": "ESS Overfrequency Start",
  "report.ESSOverFrequencyTransition": "ESS Overfrequency Transition",
  "report.ESSUnderfrequencyEnd": "ESS Underfrequency End",
  "report.ESSUnderFrequencyReloadDelay": "ESS Underfrequency Reload Delay",
  "report.ESSUnderFrequencyReloadSpeed": "ESS Underfrequency Reload Speed",
  "report.ESSUnderfrequencyReloadStart": "ESS Underfrequency Reload Start",
  "report.ESSUnderFrequencyResponseDelay": "ESS Underfrequency Response Delay",
  "report.ESSUnderFrequencySlope": "ESS Underfrequency Slope",
  "report.ESSUnderFrequencyStart": "ESS Underfrequency Start",
  "report.ESSUnderFrequencyTransition": "ESS Underfrequency Transition",
  "report.FirstOverfrequencyProtectionTime": "First Overfrequency Protection Time",
  "report.FirstOverfrequencyProtectionValue": "First Overfrequency Protection Value",
  "report.FirstOvervoltageProtectionTime": "First Overvoltage Protection Time",
  "report.FirstOvervoltageProtectionValue": "First Overvoltage Protection Value",
  "report.FirstUnderfrequencyProtectionTime": "First Underfrequency Protection Time",
  "report.FirstUnderfrequencyProtectionValue": "First Underfrequency Protection Value",
  "report.FirstUndervoltageProtectionTime": "First Undervoltage Protection Time",
  "report.FirstUndervoltageProtectionValue": "First Undervoltage Protection Value",
  "report.FixedReactivePercentage": "Fixed Reactive Percentage",
  "report.FreqHighLimit": "Frequency High Limit",
  "report.FreqLowLimit": "Frequency Low Limit",
  "report.FrequencyConfig": "Frequency Configuration",
  "report.FrequencyDerateConfig": "Frequency Derate Configuration",
  "report.FrequencyMode": "Frequency Mode",
  "report.FrequencyRecoverMax": "Maximum Frequency Recovery",
  "report.FrequencyRecoverMin": "Minimum Frequency Recovery",
  "report.GridVoltageDropMinPower": "Minimum inverter export power percentage",
  "report.GridVoltageDropStart": "Start voltage of the derating curve",
  "report.GridVoltageDropStop": "End voltage of the derating curve",
  "report.HighVoltEndValue4": "High Voltage End Value 4",
  "report.HighVoltEndValue5": "High Voltage End Value 5",
  "report.HighVoltStartValue4": "High Voltage Start Value 4",
  "report.HighVoltStartValue5": "High Voltage Start Value 5",
  "report.LockinPower4": "Lock-in Power 4",
  "report.LockinPower5": "Lock-in Power 5",
  "report.LockinV": "Lock-in Voltage",
  "report.LockoutPower4": "Lockout Power 4",
  "report.LockoutPower5": "Lockout Power 5",
  "report.LockoutV": "Lockout Voltage",
  "report.LogicDerateSpeed": "Logic Reduction Speed",
  "report.LogicInterface": "Logic Interface",
  "report.LogicReloadSpeed": "Logic Interface Recharge Speed",
  "report.LowVoltEndValue4": "Low Voltage End Value 4",
  "report.LowVoltEndValue5": "Low Voltage End Value 5",
  "report.LowVoltStartValue4": "Low Voltage Start Value 4",
  "report.LowVoltStartValue5": "Low Voltage Start Value 5",
  "report.MaximumPowerCalculationEnable": "Enable Maximum Power Calculation",
  "report.MaxLaggingReactivePower4": "Maximum Lagging Reactive Power 4",
  "report.MaxLeadingReactivePower4": "Maximum Leading Reactive Power 4",
  "report.MaxReactivePower5": "Maximum Reactive Power 5",
  "report.OverfrequencyEnd": "Overfrequency End",
  "report.OverfrequencyReloadDelay": "Overfrequency Reload Delay",
  "report.OverfrequencyReloadSpeed": "Overfrequency Reload Speed",
  "report.OverfrequencyReloadStart": "Overfrequency Reload Start",
  "report.OverfrequencyResponseDelay": "Overfrequency Response Delay",
  "report.OverfrequencySlope": "Overfrequency Slope",
  "report.OverfrequencyStart": "Overfrequency Start",
  "report.OvervoltageDownSpeed": "Overvoltage Down Speed in %Pn per minute",
  "report.PhaseType": "Phase Type",
  "report.PowerDerateLeadingByHighACVoltage": "Power Derate Leading By High AC Voltage",
  "report.PowerFactor": "Power Factor",
  "report.PowerForLogic1": "Power for Logic Interface 1",
  "report.PowerForLogic2": "Power for Logic Interface 2",
  "report.PowerForLogic3": "Power for Logic Interface 3",
  "report.PowerForLogic4": "Power for Logic Interface 4",
  "report.PowerForLogic5": "Power for Logic Interface 5",
  "report.PowerForLogic6": "Power for Logic Interface 6",
  "report.PowerForLogic7": "Power for Logic Interface 7",
  "report.PowerForLogic8": "Power for Logic Interface 8",
  "report.PowerUpSpeed": "Power Up Speed",
  "report.RatedFrequency": "Rated Frequency",
  "report.RatedVoltage": "Rated Voltage",
  "report.ReactiveConfig": "Reactive Configuration",
  "report.ReactiveCos1": "Reactive Cos Phi 1",
  "report.ReactiveCos2": "Reactive Cos Phi 2",
  "report.ReactiveCos3": "Reactive Cos Phi 3",
  "report.ReactiveCos4": "Reactive Cos Phi 4",
  "report.ReactivedynamicValue1": "Reactive Dynamic Value 1",
  "report.ReactivedynamicValue2": "Reactive Dynamic Value 2",
  "report.ReactivedynamicValue3": "Reactive Dynamic Value 3",
  "report.ReactivedynamicValue4": "Reactive Dynamic Value 4",
  "report.ReactiveMode1": "Mode cosφ fixed",
  "report.ReactiveMode2": "Mode Q fixed",
  "report.ReactiveMode3": "Mode cosφ(P)",
  "report.ReactiveMode4": "Mode Q(vac)",
  "report.ReactiveMode5": "Reactive Mode 5",
  "report.ReactiveMode6": "Reactive Mode 6",
  "report.ReactiveModeFourAustrianEnableBit": "Reactive Mode 4 Austrian Enable Bit",
  "report.ReactivePowerMode": "Reactive Power Mode",
  "report.ReactivePowerOffset4": "Reactive Power Offset 4",
  "report.ReactivePowerStart4": "Reactive Power Start 4",
  "report.ReactiveResponsePeriod": "Reactive Response Period",
  "report.ReactiveResponseWaitTime4": "Reactive Response Wait Time 4",
  "report.ReactiveResponseWaitTime5": "Reactive Response Wait Time 5",
  "report.ReconnectFreqHighLimit": "Reconnect Frequency High Limit",
  "report.ReconnectFreqLowLimit": "Reconnect Frequency Low Limit",
  "report.ReconnectPowerUpSpeed": "Reconnect Power Up Speed",
  "report.ReconnectVoltHighLimit": "Reconnect Voltage High Limit",
  "report.ReconnectVoltLowLimit": "Reconnect Voltage Low Limit",
  "report.ReconnectWaitTime": "Reconnect Wait Time",
  "report.RefluxOVloadTime": "Anti-Backflow Overload Time",
  "report.RefluxPower": "Anti-Backflow Power",
  "report.RemoteConfig": "Remote Configuration",
  "report.RemoteOnOffControl": "Remote On/Off Control",
  "report.SecondOverfrequencyProtectionTime": "Second Overfrequency Protection Time",
  "report.SecondOverfrequencyProtectionValue": "Second Overfrequency Protection Value",
  "report.SecondOvervoltageProtectionTime": "Second Overvoltage Protection Time",
  "report.SecondOvervoltageProtectionValue": "Second Overvoltage Protection Value",
  "report.SecondUnderfrequencyProtectionTime": "Second Underfrequency Protection Time",
  "report.SecondUnderfrequencyProtectionValue": "Second Underfrequency Protection Value",
  "report.SecondUndervoltageProtectionTime": "Second Undervoltage Protection Time",
  "report.SecondUndervoltageProtectionValue": "Second Undervoltage Protection Value",
  "report.SlopeMode": "Slope Mode",
  "report.TenMinOvervoltageProtectionValue": "10 Minute Overvoltage Protection Value",
  "report.ThirdOverfrequencyProtectionTime": "Third Overfrequency Protection Time",
  "report.ThirdOverfrequencyProtectionValue": "Third Overfrequency Protection Value",
  "report.ThirdOvervoltageProtectionTime": "Third Overvoltage Protection Time",
  "report.ThirdOvervoltageProtectionValue": "Third Overvoltage Protection Value",
  "report.ThirdUnderfrequencyProtectionTime": "Third Underfrequency Protection Time",
  "report.ThirdUnderfrequencyProtectionValue": "Third Underfrequency Protection Value",
  "report.ThirdUndervoltageProtectionTime": "Third Undervoltage Protection Time",
  "report.ThirdUndervoltageProtectionValue": "Third Undervoltage Protection Value",
  "report.UnderfrequencyEnd": "Underfrequency End",
  "report.UnderfrequencyReloadDelay": "Underfrequency Reload Delay",
  "report.UnderfrequencyReloadSpeed": "Underfrequency Reload Speed",
  "report.UnderfrequencyReloadStart": "Underfrequency Reload Start",
  "report.UnderfrequencyResponseDelay": "Underfrequency Response Delay",
  "report.UnderfrequencySlope": "Underfrequency Slope",
  "report.UnderfrequencyStart": "Underfrequency Start",
  "report.VoltageConfig": "Voltage Configuration",
  "report.VoltageDerateResponseTime": "Voltage Reduction Response Time",
  "report.VoltageDropoutPTCurveEnable": "Enable Voltage Dropout PT Curve",
  "report.VoltHighLimit": "Voltage High Limit",
  "report.VoltLowLimit": "Voltage Low Limit",
  "WorkMode.generatorMode": "Generator mode",
  "WorkMode.notAvailable": "Not Available",
  "WorkMode.offGridMode": "Off-grid mode",
  "WorkMode.passiveMode": "Passive mode",
  "WorkMode.peakClippingMode": "Peak clipping mode",
  "WorkMode.spontaneousSelfUseMode": "Automatic mode",
  "WorkMode.timeOfUseElectricityPriceModel": "Time-of-use electricity price model",
  "WorkMode.timingChargingAndDischargingMode": "Timing charging and discharging mode",
});

@Injectable({
  providedIn: 'root',
})
export class ModbusServicesService {

  get labels(): typeof modbusServicesLabels {
    return modbusServicesLabels;
  }

  updateLabels(labels: Partial<typeof modbusServicesLabels>): void {
    Object.assign(this.labels, labels);
  }
}
